import { useDebounceFn } from 'ahooks';

export const useDropdownOnOpenChange = (
  callbackFn: (rowId: string | undefined) => void
) => {
  // Because of the way the dropdown works, or more specific, when the onMouseDown and onClickOutside events are triggered.
  // We get first the onMouseDown event and then the onClickOutside event when we click from one dropdown to another.
  // This causes the dropdown to close last and to lose the selected column. This is why we need to debounce (to call last)
  // the onSelectedColumnChange function while opening the menu.
  const { run: debouncedOnOpen } = useDebounceFn(callbackFn, {
    wait: 0,
  });

  return {
    onOpenChange: (isOpen: boolean | undefined, onOpenValue: string) => {
      if (isOpen) {
        debouncedOnOpen(onOpenValue);
        return;
      }

      callbackFn(undefined);
    },
  };
};
